import React, { FC, useCallback } from 'react';
import { InputGroup, Keys } from '@blueprintjs/core';
// Types
import { ITableFilterProps } from '../TableFilter';

interface ITableStringFilterProps extends ITableFilterProps {
  filterValue?: string;
}

const StringFilter: FC<ITableStringFilterProps> = ({
  field,
  label,
  onFilterChange,
  onPressEnter,
  filterValue = '',
}) => {
  const handleChange = useCallback(
    (e) => {
      onFilterChange(field, e.target.value);
    },
    [field, onFilterChange]
  );

  const handleKeyPress = useCallback(
    (e) => {
      if (e.which === Keys.ENTER && onPressEnter) {
        onPressEnter();
      }
    },
    [onPressEnter]
  );

  return (
    <div key={field}>
      <InputGroup
        onKeyPress={handleKeyPress}
        onChange={handleChange}
        placeholder={label}
        value={filterValue}
      />
    </div>
  );
};

export default StringFilter;
